// Kleine fetch-helpers die de oude jQuery-ajax-semantiek behouden:
// - form-encoded params (URLSearchParams), zoals $.post stuurde
// - CSRF-token uit de meta-tag (csrf_meta_tags in de layout)
// - getJSON gooit op HTTP-fouten; pollers vangen dat zelf silent af,
//   net als de oude $.getJSON zonder .fail-handler deed.

function csrfToken() {
  const el = document.querySelector('meta[name="csrf-token"]');
  return el ? el.content : '';
}

export function getJSON(url) {
  return fetch(url, { headers: { 'Accept': 'application/json' } })
    .then(function (r) {
      if (!r.ok) throw httpError(r);
      return r.json();
    });
}

// $.getJSON-equivalent: haalt JSON op en roept cb aan; fouten zijn silent,
// zoals de oude pollers zonder .fail-handler dat waren.
export function pollJSON(url, cb) {
  return getJSON(url).then(cb).catch(function () {});
}

// Een foutcode wordt een Error mét de response, zodat de aanroeper de uitleg van
// de server nog kan lezen (e.response.json()); anders bleef er alleen
// "HTTP 422" over.
function httpError(response) {
  var err = new Error('HTTP ' + response.status);
  err.response = response;
  return err;
}

// POST met form-encoded body (zoals $.post). Geeft de Response terug;
// call-sites parsen zelf (of negeren de body, zoals voorheen).
export function postForm(url, data) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrfToken(),
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json, text/javascript, */*'
    },
    body: new URLSearchParams(data || {})
  }).then(function (r) {
    if (!r.ok) throw httpError(r);
    return r;
  });
}

// POST met JSON-body (voor endpoints die application/json verwachten).
export function postJSON(url, payload) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrfToken(),
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(function (r) {
    if (!r.ok) throw httpError(r);
    return r.json().catch(function () { return {}; });
  });
}
